
import actionTypes from '../actions/reduxActions/actionTypes';

const APIEndpoints = (state = { endpoints: {} }, { type, payload, error, meta }) => {

    switch (type) {

    case actionTypes.SET_API_ENDPOINTS:
        return { ...state, endpoints: payload };

    case actionTypes.SET_SELECTED_FLOW:
        return { ...state, selectedFlow: payload };

    default:
        return state;
    }
};

export default APIEndpoints;
